module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/Logo_SCT_Outil_Pro_small.ef2417d2.png";